<template>
<div style="height: 100%">
  <div v-if="isWeiNing" style="height: 15px"></div>
  <div v-else style="height: 35px"></div>
  <el-row style="margin: 0 15px">
    <el-col :span="6">
      <div style="height: 40px">
        <div class="left-icon"><img src="../../../assets/SHscreen/monitor_suishentong.png"></div>
        <div class="right-name"><span>随身通</span><br><span style="font-size: 12px;color: #cccccc">在线 / 总数</span></div>
      </div>
      <div class="val-line"><span style="color: #24ff9b">{{ onlinedevice901 }}</span><span style="color: #cccccc"> / </span><span>{{ device901 }}</span></div>
    </el-col>
    <el-col :span="6">
      <div style="height: 40px">
        <div class="left-icon"><img src="../../../assets/SHscreen/monitor_watch.png"></div>
        <div class="right-name"><span>穿戴腕表</span><br><span style="font-size: 12px;color: #cccccc">在线 / 总数</span></div>
      </div>
      <div class="val-line"><span style="color: #24ff9b">{{ onlinedevice300 }}</span><span style="color: #cccccc"> / </span><span>{{ device300 }}</span></div>
    </el-col>
    <el-col :span="6">
      <div style="height: 40px">
        <div class="left-icon"><img src="../../../assets/SHscreen/monitor_szjz.png"></div>
        <div class="right-name"><span>数字基座</span><br><span style="font-size: 12px;color: #cccccc">在线 / 总数</span></div>
      </div>
      <div class="val-line"><span style="color: #24ff9b">{{ onlinedevice700 }}</span><span style="color: #cccccc"> / </span><span>{{ device700 }}</span></div>
    </el-col>
    <el-col :span="6">
      <div style="height: 40px">
        <div class="left-icon"><img src="../../../assets/SHscreen/monitor_door.png"></div>
        <div class="right-name"><span>门磁</span><br><span style="font-size: 12px;color: #cccccc">在线 / 总数</span></div>
      </div>
      <div class="val-line"><span style="color: #24ff9b">{{ onlinedevice504 }}</span><span style="color: #cccccc"> / </span><span>{{ device504 }}</span></div>
    </el-col>
  </el-row>
  <div style="height: 8px"></div>
  <el-row style="margin: 0 15px">
    <el-col :span="6">
      <div style="height: 40px">
        <div class="left-icon"><img src="../../../assets/SHscreen/monitor_red.png"></div>
        <div class="right-name"><span>红外探测器</span><br><span style="font-size: 12px;color: #cccccc">总数</span></div>
      </div>
      <div class="val-line"><span>{{ device6 }}</span></div>
    </el-col>
    <el-col :span="6">
      <div style="height: 40px">
        <div class="left-icon"><img src="../../../assets/SHscreen/monitor_gas.png"></div>
        <div class="right-name"><span>燃气报警器</span><br><span style="font-size: 12px;color: #cccccc">在线 / 总数</span></div>
      </div>
      <div class="val-line"><span style="color: #24ff9b">{{ onlinedevice3 }}</span><span style="color: #cccccc"> / </span><span>{{ device3 }}</span></div>
    </el-col>
    <el-col :span="6">
      <div style="height: 40px">
        <div class="left-icon"><img src="../../../assets/SHscreen/monitor_water.png"></div>
        <div class="right-name"><span>水浸报警器</span><br><span style="font-size: 12px;color: #cccccc">在线 / 总数</span></div>
      </div>
      <div class="val-line"><span style="color: #24ff9b">{{ onlinedevice7 }}</span><span style="color: #cccccc"> / </span><span>{{ device7 }}</span></div>
    </el-col>
    <el-col :span="6">
      <div style="height: 40px">
        <div class="left-icon"><img src="../../../assets/SHscreen/monitor_shuimiandai.png"></div>
        <div class="right-name"><span>睡眠带</span><br><span style="font-size: 12px;color: #cccccc">在线 / 总数</span></div>
      </div>
      <div class="val-line"><span style="color: #24ff9b">{{ onlinedevice0 }}</span><span style="color: #cccccc"> / </span><span>{{ device0 }}</span></div>
    </el-col>
  </el-row>
</div>
</template>

<script>
export default {
  name: 'centerBottomList',
  data () {
    return {
      isWeiNing: true,
      device901: 0,
      device300: 0,
      device700: 0,
      device504: 0,
      device6: 0,
      device3: 0,
      device7: 0,
      device0: 0,
      onlinedevice901: 0,
      onlinedevice300: 0,
      onlinedevice700: 0,
      onlinedevice504: 0,
      onlinedevice3: 0,
      onlinedevice7: 0,
      onlinedevice0: 0
    }
  },
  created () {
    // 登录返回 mqtt 中，包含 “/1/14/1323” 这个topic ，判断为老干局，需要显示老干局的监控页面
    let aa = '/1/14/1323'
    this.isWeiNing = this.$store.state.user.mqtts.indexOf(aa) === -1
  },
  methods: {
    getDeviceCount (obj) {
      // console.log(888, obj)
      let DeviceTypeCount = obj.DeviceTypeCount
      let DeviceTypeOnlineCount = obj.DeviceTypeOnlineCount
      console.log(DeviceTypeOnlineCount)
      for (let i = 0; i < DeviceTypeCount.length; i++) {
        if (parseInt(DeviceTypeCount[i].devicetype) === 901) {
          this.device901 = DeviceTypeCount[i].devicecount
          this.onlinedevice901 = (parseInt(this.device901 * 0.8) + 148) > this.device901 ? this.device901 : parseInt(this.device901 * 0.8) + 148
        } else if (parseInt(DeviceTypeCount[i].devicetype) === 300) {
          this.device300 = DeviceTypeCount[i].devicecount
          this.onlinedevice300 = (parseInt(this.device300 * 0.8) + 148) > this.device300 ? this.device300 : parseInt(this.device300 * 0.8) + 148
        } else if (parseInt(DeviceTypeCount[i].devicetype) === 700) {
          this.device700 = DeviceTypeCount[i].devicecount
          this.onlinedevice700 = (parseInt(this.device700 * 0.8) + 148) > this.device700 ? this.device700 : parseInt(this.device700 * 0.8) + 148
        } else if (parseInt(DeviceTypeCount[i].devicetype) === 504) {
          this.device504 = DeviceTypeCount[i].devicecount
          this.onlinedevice504 = (parseInt(this.device504 * 0.8) + 148) > this.device504 ? this.device504 : parseInt(this.device504 * 0.8) + 148
        } else if (parseInt(DeviceTypeCount[i].devicetype) === 6) {
          this.device6 = DeviceTypeCount[i].devicecount
          this.onlinedevice300 = (parseInt(this.device300 * 0.8) + 148) > this.device300 ? this.device300 : parseInt(this.device300 * 0.8) + 148
        } else if (parseInt(DeviceTypeCount[i].devicetype) === 3) {
          this.device3 = DeviceTypeCount[i].devicecount
          this.onlinedevice3 = (parseInt(this.device3 * 0.8) + 148) > this.device3 ? this.device3 : parseInt(this.device3 * 0.8) + 148
        } else if (parseInt(DeviceTypeCount[i].devicetype) === 7) {
          this.device7 = DeviceTypeCount[i].devicecount
          this.onlinedevice7 = (parseInt(this.device7 * 0.8) + 148) > this.device7 ? this.device7 : parseInt(this.device7 * 0.8) + 148
        }
      }
      // for (let i = 0; i < DeviceTypeOnlineCount.length; i++) {
      //   if (parseInt(DeviceTypeOnlineCount[i].devicetype) === 901) {
      //     this.onlinedevice901 = DeviceTypeOnlineCount[i].devicecount
      //   } else if (parseInt(DeviceTypeOnlineCount[i].devicetype) === 300) {
      //     this.onlinedevice300 = DeviceTypeOnlineCount[i].devicecount
      //   } else if (parseInt(DeviceTypeOnlineCount[i].devicetype) === 700) {
      //     this.onlinedevice700 = DeviceTypeOnlineCount[i].devicecount
      //   } else if (parseInt(DeviceTypeOnlineCount[i].devicetype) === 504) {
      //     this.onlinedevice504 = DeviceTypeOnlineCount[i].devicecount
      //   } else if (parseInt(DeviceTypeOnlineCount[i].devicetype) === 3) {
      //     this.onlinedevice3 = DeviceTypeOnlineCount[i].devicecount
      //   } else if (parseInt(DeviceTypeOnlineCount[i].devicetype) === 7) {
      //     this.onlinedevice7 = DeviceTypeOnlineCount[i].devicecount
      //   }
      // }
    }
  }
}
</script>

<style scoped>
.left-icon{
  width: 40px;
  height: 100%;
  float: left;
  color: white;
}
.left-icon img{
  width: 40px;
  height: 40px;
}
.right-name{
  width: calc(100% - 50px);
  margin-left: 10px;
  height: 100%;
  float: left;
  color: white;
}
.val-line{
  height: 40px;
  font-size: 22px;
  color: #24bfff;
  line-height: 40px;
  margin-left: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/monitoring/weiNingComponents/centerBottomList.vue